<template>
  <div>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-container">
            <div class="modal-header text-white">
              <h5 class="modal-title">Teilnehmer einladen</h5>
              <button
                type="button"
                class="close text-white"
                @click="$emit('close')"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true" @click="showModal = false"
                  >&times;</span
                >
              </button>
            </div>
            <div class="nav-bar p-1 text-primary">
              <button
                type="button"
                @click="$emit('toggleTab', 0)"
                class="btn btn-outline-primary btn-custom"
              >
                <font-awesome-icon class :icon="['fal', 'envelope']" />
              </button>
              <button
                type="button"
                @click="$emit('toggleTab', 1)"
                class="btn btn-outline-primary btn-custom ml-3"
              >
                <font-awesome-icon class :icon="['fal', 'link']" />
              </button>
              <button
                type="button"
                @click="$emit('toggleTab', 2)"
                class="btn btn-primary text-white btn-custom ml-3"
              >
                <font-awesome-icon class :icon="['fal', 'users']" />
              </button>
            </div>
            <div class="modal-body">
              <p>Show the overview of the invitations</p>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                @click="$emit('close')"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'LinkInvite',
  props: {},

  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/colors.scss';
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: top;
}

.modal-container {
  border: 1px solid$primary;

  .nav-bar {
    text-align: left;
    .btn {
      padding: 0.1rem;
    }
  }

  .btn-custom {
    width: 78px !important;
  }
}

.modal-container {
  width: 900px;
  margin: 0px auto;
  margin-top: 75px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header {
  background-color: $primary;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 5px 0;
  padding: 0.1rem;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
